import api from "./api";
const ProfileAPI = {
    updUserAvatar: (formData) => api.post("/user/profile/avatar", formData),
    getUserAvatar: () => api.get("/user/profile/avatar"),
    requestUpdateLogin: (data) => api.post("/user/profile/request-update-login", data),
    verifyUpdateLogin: (data) => api.post("/user/profile/verify-update-login", data),
};
export default ProfileAPI;
